import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NoiseAbatement } from '../models/noise-abatement.model';


@Injectable()
export class NoiseAbatementService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * updates specified entity via api
   * @param {number} airportID
   * @param {NoiseAbatement} noise
   * @return {Promise<any>}
   */
  putNoiseAbatement(airportID: number, noise: NoiseAbatement): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/noises/${noise.id}`;
    try {
      const BODY = this._getNoiseAbatementJSON(noise);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * adds specified entity via api
   * @param {number} airportID
   * @param {NoiseAbatement} noise
   * @return {Promise<any>}
   */
  postNoiseAbatement(airportID: number, noise: NoiseAbatement): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/noises/`;
    try {
      const BODY = this._getNoiseAbatementJSON(noise);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * deletes specified entity via api
   * @param {number} airportID
   * @param {number} noiseID
   * @return {Promise<any>}
   */
  deleteNoiseAbatement(airportID: number, noiseID: number): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/noises/${noiseID}`;
    try {
      return this._http.delete(URL).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts entity to json obj
   * @param {NoiseAbatement} noise
   * @return {any}
   * @private
   */
  _getNoiseAbatementJSON (noise: NoiseAbatement): any {
    return {
      runway: noise.runway,
      appliesTo: NoiseAbatement.formatAppliesTo(noise.appliesTo),
      appDep: NoiseAbatement.formatAppDep(noise.appDep),
      text: noise.text
    };
  }
}
